var _g, _path, _g2, _path2, _path3, _g3, _path4, _circle, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginLoggo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 197,
    viewBox: "0 0 197 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7141_25673)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 95.5,
    r: 77.5,
    fill: "#E0E8FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 95.5,
    r: 79.5395,
    stroke: "white",
    strokeWidth: 4.07895
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7141_25673",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 18,
    width: 155,
    height: 155
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176 95.5C176 138.302 141.302 173 98.5 173C55.6979 173 21 138.302 21 95.5C21 52.6979 55.6979 18 98.5 18C141.302 18 176 52.6979 176 95.5Z",
    fill: "#08AE36"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7141_25673)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 18,
    width: 77.2008,
    height: 155,
    fill: "#ECF1FF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8132 33.0404C98.9117 32.2365 97.5498 32.2365 96.6482 33.0404L40.4004 83.1955C38.7718 84.6477 39.8 87.3412 41.9829 87.3412H58.3386V125.924H52.2275C50.915 125.924 49.8509 126.987 49.8509 128.298V139.831C49.8509 141.142 50.915 142.205 52.2275 142.205H144.234C145.547 142.205 146.611 141.142 146.611 139.831V128.298C146.611 126.987 145.547 125.924 144.234 125.924H138.123V87.3412H154.479C156.661 87.3412 157.69 84.6477 156.061 83.1955L135.746 65.0812V41.1267C135.746 39.8154 134.682 38.7523 133.37 38.7523H121.487C120.174 38.7523 119.11 39.8154 119.11 41.1267V50.2474L99.8132 33.0404Z",
    fill: "#1536E7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7141_25673",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 32,
    width: 119,
    height: 111
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9851 33.0443C99.0835 32.2404 97.7217 32.2404 96.8201 33.0443L40.5723 83.1994C38.9437 84.6516 39.9719 87.3451 42.1548 87.3451H58.5105V125.928H52.3994C51.0868 125.928 50.0228 126.991 50.0228 128.302V139.835C50.0228 141.146 51.0868 142.209 52.3994 142.209H144.406C145.718 142.209 146.782 141.146 146.782 139.835V128.302C146.782 126.991 145.718 125.928 144.406 125.928H138.295V87.3451H154.65C156.833 87.3451 157.862 84.6516 156.233 83.1994L135.918 65.0851V41.1306C135.918 39.8193 134.854 38.7562 133.542 38.7562H121.659C120.346 38.7562 119.282 39.8193 119.282 41.1306V50.2513L99.9851 33.0443Z",
    fill: "#F5F3FC"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7141_25673)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.9453,
    y: 26.9727,
    width: 64.2472,
    height: 127.918,
    fill: "#3854EB"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.3 111.803C114.75 108.585 120.755 100.455 120.755 90.9219C120.755 78.5649 110.664 68.5649 98.2382 68.5649C85.812 68.5649 75.7211 78.5649 75.7211 90.9219C75.7211 100.088 81.2734 107.957 89.2125 111.41V146.883C89.1788 147.631 89.3738 149.191 90.3979 150.508L91.4568 149.684L90.3979 150.508C91.1988 151.537 92.4257 153.076 92.938 153.715L95.3261 156.695V156.513L95.6461 156.993C95.9085 157.431 96.4064 157.939 97.1505 158.155C97.9974 158.4 98.9043 158.194 99.7459 157.574C100.168 157.263 100.718 156.68 101.261 156.066C101.837 155.415 102.503 154.613 103.181 153.772C104.519 152.115 105.932 150.271 106.844 149.055C107.212 148.633 107.336 148.056 107.231 147.506C107.118 146.917 106.762 146.395 106.281 145.942C105.795 145.483 105.024 144.73 104.403 144.119L106.178 140.855L106.209 140.798L106.234 140.738C106.564 139.962 106.527 138.619 105.378 137.535C104.882 137.068 103.758 135.798 102.88 134.783L104.849 132.463L105.609 131.566L104.82 130.695L104.244 130.058L105.393 128.938L106.223 128.131L105.546 127.193L103.122 123.831L106.25 120.487L106.951 119.738L106.411 118.865L104.452 115.702C105.102 114.742 105.808 113.398 106.3 111.803ZM95.4006 113.312C95.4006 113.312 95.3999 113.314 95.3984 113.316C95.3998 113.313 95.4006 113.312 95.4006 113.312Z",
    fill: "#FF9F10",
    stroke: "white",
    strokeWidth: 2.68279
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.75372,
    cy: 4.75372,
    r: 4.75372,
    transform: "matrix(1 0 0 -1 93.6016 85.3711)",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 98.5,
    y: 20.9141,
    width: 0.288104,
    height: 0.288104,
    fill: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7141_25673",
    x: 0.606087,
    y: 0.869245,
    width: 195.788,
    height: 195.788,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.26316
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.15789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7141_25673"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7141_25673",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLoggo);
export default __webpack_public_path__ + "static/media/loginLoggo.9089329e102b1668666fbbb3893b94f9.svg";
export { ForwardRef as ReactComponent };